import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/report-schedules'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT_SCHEDULES.HEADER',
        icon: 'arrow-download',
      },
      children: [
        {
          path: '',
          name: 'report_schedules_index',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
